<template>
  <div
    class="my-3 bg-grey-95"
    :class="classes"/>
</template>

<script>
export default {
  props: {
    direction: {
      type: String,
      default: 'horizontal'
    }
  },

  data () {
    return {
      directions: {
        horizontal: [
          'h-px'
        ],
        vertical: [
          'w-px',
          'h-full',
          'inline-block'
        ]
      }
    }
  },

  computed: {
    classes () {
      return this.directions[this.direction]
    }
  }
}
</script>
